export enum ControlType {
  Immediately,
  After,
  Before,
}
